/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { calloutModalLinkClick } from '../../../analytics';

export default (set, get, feature, callout) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackCalloutModalLinkClick = { feature, callout };

  draft.digitalData.calloutModalLinkClick = trackCalloutModalLinkClick;

  calloutModalLinkClick(trackCalloutModalLinkClick);
}), false, { type: 'TRACK_CALLOUT_MODAL_LINK_CLICK' });
